// extracted by mini-css-extract-plugin
module.exports = {"block":"layout2_block__1LuTs","blockTeacher":"layout2_blockTeacher__1FZFN"};